import React from "react";
import { Box, Typography } from "@mui/material";
export const GridCellStack = ({ topText, bottomText, topVariant = "body2", bottomVariant = "body2", topColor = "text.primary", bottomColor = "text.secondary", topStyle, bottomStyle, noWrap, }) => {
    return (React.createElement(Box, null,
        React.createElement(Typography, { variant: topVariant, color: topColor, style: topStyle, noWrap: noWrap }, topText),
        React.createElement(Typography, { variant: bottomVariant, color: bottomColor, style: bottomStyle, noWrap: noWrap }, bottomText)));
};
